import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Typography, Stack, Tooltip, IconButton, Button } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';

const OpportunityMatchListItem = ({ match }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [showCopied, setShowCopied] = useState(false);
    const [isAboutExpanded, setIsAboutExpanded] = useState(false);

    const handleCopyEmail = async () => {
        await navigator.clipboard.writeText(match.user.email);
        setShowCopied(true);
        setTimeout(() => setShowCopied(false), 3000);
    };

    return (
        <React.Fragment>
            <ListItem alignItems="flex-start">
                <ListItemAvatar>
                    <Link to={`/profile/${match.user.userId}`} style={{ textDecoration: 'none' }}>
                        <Avatar 
                            alt={match.user.firstName + " " + match.user.lastName} 
                            src={match.user.hasPicture ? match.user.profilePictureUrl : null}
                        />
                    </Link>
                </ListItemAvatar>
                <ListItemText
                    primary={
                        <Link 
                            to={`/profile/${match.user.userId}`} 
                            style={{ textDecoration: 'none', color: 'inherit' }}
                        >
                            {match.user.firstName + " " + match.user.lastName}
                        </Link>
                    }
                    secondary={
                        <Stack>
                            <Stack direction="row" alignItems="center" spacing={1}>
                                <Typography
                                    component="span"
                                    variant="body2"
                                    sx={{ display: 'inline' }}
                                >
                                    <a href={"mailto:" + match.user.email}>{match.user.email}</a>
                                </Typography>
                                <Tooltip 
                                    title="Copied!"
                                    open={showCopied}
                                    placement="top"
                                    arrow
                                    disableFocusListener
                                    disableHoverListener
                                    disableTouchListener
                                >
                                    <IconButton 
                                        size="small" 
                                        onClick={handleCopyEmail}
                                        sx={{ 
                                            padding: '1px',
                                            width: '16px',
                                            height: '16px'
                                        }}
                                    >
                                        <ContentCopyIcon sx={{ fontSize: '14px' }} />
                                    </IconButton>
                                </Tooltip>
                            </Stack>
                            <Typography
                                component="span"
                                variant="body2"
                                sx={{ display: 'inline' }}
                            >
                                {match.user.phoneNumber}
                            </Typography>

                            <Stack direction="row" justifyContent="flex-start" sx={{ mt: 0.5 }}>
                                <Button
                                    size="small"
                                    variant="outlined"
                                    startIcon={<ChatBubbleOutlineIcon sx={{ fontSize: '0.9rem' }} />}
                                    onClick={() => navigate(`/messages/${match.user.userId}`)}
                                    sx={{ textTransform: 'none' }}
                                >
                                    {t('messages.message')}
                                </Button>
                            </Stack>

                            {match.user.aboutYou && (
                                <>
                                    <Stack direction="row" justifyContent="flex-start">
                                        <Button
                                            onClick={() => setIsAboutExpanded(!isAboutExpanded)}
                                            endIcon={
                                                <ExpandMoreIcon 
                                                    sx={{ 
                                                        transform: isAboutExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                                                        transition: 'transform 0.2s'
                                                    }}
                                                />
                                            }
                                            sx={{ 
                                                textTransform: 'none',
                                                padding: '0',
                                                color: 'text.secondary',
                                                minWidth: 'auto'
                                            }}
                                        >
                                            About
                                        </Button>
                                    </Stack>
                                    {isAboutExpanded && (
                                        <Typography
                                            component="span"
                                            variant="body2"
                                            sx={{ 
                                                display: 'inline',
                                                pl: 1
                                            }}
                                        >
                                            {match.user.aboutYou}
                                        </Typography>
                                    )}
                                </>
                            )}
                            
                        </Stack>
                    }
                />
            </ListItem>
        </React.Fragment>
    );
};

export default OpportunityMatchListItem;
